module.exports = __webpack_public_path__ + "static/media/FanSaves_Excited_Girl-_Transparent-_1000x1000.bb548fdc.png";